module.exports = __webpack_public_path__ + "img/edit-solid-blue.c893a55d.svg";